/** Kannada: putting the web app on the home screen. */
export const install = {
    "install.title": "GigSync ಅನ್ನು ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ಗೆ ಸೇರಿಸಿ",
    "install.about": "ಇದು ಆ್ಯಪ್‌ನಂತೆ ತೆರೆಯುತ್ತದೆ, ನೆಟ್‌ವರ್ಕ್ ಇಲ್ಲದಿದ್ದರೂ.",
    "install.button": "ಆ್ಯಪ್ ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಿ",
    "install.ios": "ಶೇರ್ ಬಟನ್ ಒತ್ತಿ, ನಂತರ ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ಗೆ ಸೇರಿಸುವ ಆಯ್ಕೆ ಆರಿಸಿ.",
    "install.ios_first": "ಸೈನ್ ಇನ್ ಮಾಡುವ ಮೊದಲೇ ಇದನ್ನು ಮಾಡಿ: iPhone ನಲ್ಲಿ ಹೋಮ್ ಸ್ಕ್ರೀನ್ ಆ್ಯಪ್ ತನ್ನ ಡೇಟಾವನ್ನು Safari ಯಿಂದ ಬೇರೆಯಾಗಿ ಇಡುತ್ತದೆ.",
    "install.later": "ಈಗ ಬೇಡ",
    "install.screen": "GigSync ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಿ",
    "install.on_iphone": "ನಿಮ್ಮ iPhone ನಲ್ಲಿ GigSync",
    "install.on_phone": "ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲಿ GigSync",
    "install.on_computer": "ನಿಮ್ಮ ಕಂಪ್ಯೂಟರ್‌ನಲ್ಲಿ GigSync",
    "install.installed": "GigSync ಇನ್‌ಸ್ಟಾಲ್ ಆಗಿದೆ: ನೀವು ಈಗ ಆ್ಯಪ್‌ನಲ್ಲೇ ಇದ್ದೀರಿ.",
    "install.ios_share": "ಶೇರ್ ಒತ್ತಿ: ಕೆಳಗೆ ಬಾಣದ ಗುರುತಿನ ಚೌಕ, ಅಥವಾ ⋯ ಒಳಗೆ.",
    "install.other_share": "ಮೇಲೆ ಬಲಭಾಗದಲ್ಲಿ ಶೇರ್ ಒತ್ತಿ, ಅಥವಾ ಈ ಪುಟವನ್ನು Safari ಯಲ್ಲಿ ತೆರೆಯಿರಿ.",
    "install.ios_add": "ಕೆಳಗೆ ಸರಿಸಿ, ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ಗೆ ಸೇರಿಸುವ ಆಯ್ಕೆ (Add to Home Screen) ಆರಿಸಿ.",
    "install.ios_keep": "ವೆಬ್ ಆ್ಯಪ್ ಆಗಿ ತೆರೆಯುವ ಆಯ್ಕೆ (Open as Web App) ಆನ್ ಇರಲಿ, ನಂತರ Add ಒತ್ತಿ.",
    "install.ios_open": "ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ನಿಂದ GigSync ತೆರೆಯಿರಿ.",
    "install.ios_apart": "ಸೈನ್ ಇನ್ ಮಾಡುವ ಮೊದಲೇ ಮಾಡುವುದು ಒಳ್ಳೆಯದು: iPhone ನಲ್ಲಿ ಹೋಮ್ ಸ್ಕ್ರೀನ್ ಆ್ಯಪ್ ತನ್ನ ಡೇಟಾವನ್ನು Safari ಯಿಂದ ಬೇರೆಯಾಗಿ ಇಡುತ್ತದೆ, ಹಾಗಾಗಿ ಅಲ್ಲಿ ಮತ್ತೆ ಸೈನ್ ಇನ್ ಮಾಡಬೇಕು.",
    "install.android_menu": "Chrome ನಲ್ಲಿ ಮೇಲೆ ಬಲಭಾಗದ ⋮ ಒತ್ತಿ.",
    "install.android_pick": "ಆ್ಯಪ್ ಇನ್‌ಸ್ಟಾಲ್ (Install app) ಅಥವಾ ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ಗೆ ಸೇರಿಸುವ (Add to Home screen) ಆಯ್ಕೆ ಆರಿಸಿ.",
    "install.android_open": "Install ಒತ್ತಿ, ನಂತರ ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ನಿಂದ GigSync ತೆರೆಯಿರಿ.",
    "install.computer_icon": "ಅಡ್ರೆಸ್ ಬಾರ್‌ನ ಬಲಭಾಗದ ಇನ್‌ಸ್ಟಾಲ್ ಗುರುತು ಒತ್ತಿ, ಅಥವಾ ⋮ › Cast, save and share › Install page as app ಆರಿಸಿ.",
    "install.mac_dock": "Safari ಯ ಮೇಲಿನ ಮೆನುವಿನಲ್ಲಿ File › Add to Dock ಆರಿಸಿ.",
    "install.computer_add": "Install ಒತ್ತಿ.",
    "install.mac_add": "Add ಒತ್ತಿ.",
    "install.computer_open": "GigSync ತನ್ನದೇ ವಿಂಡೋದಲ್ಲಿ ತೆರೆಯುತ್ತದೆ, ನಿಮ್ಮ ಇತರ ಆ್ಯಪ್‌ಗಳ ಜೊತೆ ಕಾಣುತ್ತದೆ.",
};
//# sourceMappingURL=install.js.map